import script from "./InstallAppBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./InstallAppBanner.vue?vue&type=script&lang=ts&setup=true"

import "./InstallAppBanner.vue?vue&type=style&index=0&id=ba9206ea&scoped=true&lang=css"

import exportComponent from "/home/tecnonet/proyectos/galidancia_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba9206ea"]])

export default __exports__